<div class="page-container">
  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <h1>SBOM Management</h1>
      <p class="subtitle">{{projects.length}} Projekte · {{totalComponents}} Komponenten · {{totalDocuments}} Dokumente</p>
    </div>
    <button mat-raised-button color="primary" (click)="openProjectForm()">
      <mat-icon>add</mat-icon> Neues Projekt
    </button>
  </div>

  <!-- Search -->
  <div class="search-bar">
    <mat-icon class="search-icon">search</mat-icon>
    <input type="text" placeholder="Projekt, Kunde, Projektnummer suchen..." [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()">
    <button mat-icon-button *ngIf="searchTerm" (click)="clearSearch()" class="clear-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="48"></mat-spinner>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && filteredProjects.length === 0" class="empty-state">
    <mat-icon>inventory</mat-icon>
    <h3>Noch keine SBOM-Projekte</h3>
    <p>Erstelle ein neues Projekt um Komponenten und Dokumente zu verwalten.</p>
    <button mat-raised-button color="primary" (click)="openProjectForm()">
      <mat-icon>add</mat-icon> Erstes Projekt anlegen
    </button>
  </div>

  <!-- Project Grid -->
  <div *ngIf="!loading && filteredProjects.length > 0" class="project-grid">
    <div class="project-card" *ngFor="let p of filteredProjects" (click)="openProject(p)" [ngClass]="getStatusClass(p.status)">
      <div class="card-header">
        <div class="project-avatar">
          <img *ngIf="p.customerLogoPath" [src]="getLogoUrl(p.customerLogoPath)" alt="Logo" class="customer-logo">
          <mat-icon *ngIf="!p.customerLogoPath">developer_board</mat-icon>
        </div>
        <div class="card-title-area">
          <h3>{{p.name}}</h3>
          <span class="customer-name">{{p.customerName}}</span>
        </div>
        <div class="card-actions">
          <button mat-icon-button (click)="openProjectForm(p); $event.stopPropagation()" matTooltip="Bearbeiten">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteProject(p, $event)" matTooltip="Löschen">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <div class="card-body">
        <div class="status-badge" [ngClass]="getStatusClass(p.status)">
          {{statusLabels[p.status]}}
        </div>
        <div class="card-info">
          <span *ngIf="p.projectNumber"><mat-icon>tag</mat-icon> {{p.projectNumber}}</span>
          <span *ngIf="p.plcType"><mat-icon>memory</mat-icon> {{p.plcType}}</span>
        </div>
      </div>

      <div class="card-stats">
        <div class="stat">
          <mat-icon>widgets</mat-icon>
          <span>{{p.componentCount}} Komponenten</span>
        </div>
        <div class="stat">
          <mat-icon>description</mat-icon>
          <span>{{p.documentCount}} Dokumente</span>
        </div>
        <div class="stat" *ngIf="p.projectHash">
          <mat-icon>fingerprint</mat-icon>
          <span>Hash vorhanden</span>
        </div>
      </div>

      <!-- Security Status -->
      <div class="card-security" *ngIf="p.securityAssessment">
        <div class="security-mini-bar">
          <div class="security-mini-fill"
               [style.width.%]="getSecurityProgress(p)"
               [style.background]="getSecurityProgress(p) >= 80 ? '#22c55e' : getSecurityProgress(p) >= 50 ? '#eab308' : '#ef4444'">
          </div>
        </div>
        <span class="security-mini-label">
          <mat-icon>security</mat-icon>
          SL {{p.securityAssessment.targetSecurityLevel}} · {{p.securityAssessment.completedRequirements}}/{{p.securityAssessment.totalRequirements}}
        </span>
      </div>
      <div class="card-security-action" *ngIf="!p.securityAssessment">
        <button mat-stroked-button class="security-start-btn"
                (click)="startSecurityCheck(p, $event)">
          <mat-icon>security</mat-icon> Sicherheitscheck
        </button>
      </div>
    </div>
  </div>
</div>
